import styled from 'styled-components'

export const LogoImage = styled.img`
max-width: 75%;
max-height 12.5rem;
margin: 0 auto;


`
